import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const NotScheduledBIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M4.51169 3.85714V0.771429M13.4883 3.85714V0.771429M4.88571 12.6H5.4M13.1143 12.6H12.6M0.771429 7.97143V16.2C0.771429 16.7681 1.23194 17.2286 1.8 17.2286H16.2C16.7681 17.2286 17.2286 16.7681 17.2286 16.2V7.97143M0.771429 7.97143V4.88571C0.771429 4.31765 1.23194 3.85714 1.8 3.85714H16.2C16.7681 3.85714 17.2286 4.31765 17.2286 4.88571V7.97143M0.771429 7.97143H17.2286M9.25714 12.6H8.74286" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </Svg>
);

NotScheduledBIcon.displayName = 'NotScheduledBIcon';
